import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Test } from '../models/test.model';
import { TestModel } from '../models/test-model.model';
import { AppConfig } from '../helpers/app.config';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from './utils.service';
import { Candidate } from '../models/candidate.model';

@Injectable({
  providedIn: 'root'
})
export class TestService {

  constructor(private httpClient: HttpClient, private translateService: TranslateService, private utilsService: UtilsService) { }

  getModels(origin = null): Observable<TestModel[]> {
    return this.httpClient.get<TestModel[]>(AppConfig.settings.API + '/tests/types' + (origin ? '?origin=' + origin : ''));
  }

  getTestResults(testId: number): Observable<Test> {
    return this.httpClient.get<Test>(AppConfig.settings.API + '/tests/results/' + testId);
  }

  getTestByToken(token: string): Observable<Test> {
    return this.httpClient.get<Test>(AppConfig.settings.API + '/tests/info/' + token);
  }

  getTestReportResults(token: string, jobtypeId: number = null): Observable<any> {
    return this.httpClient.get<Test>(AppConfig.settings.API + '/tests/report/' + token + (jobtypeId ? '?jobtypeId=' + jobtypeId : ''));
  }

  putAcceptTerms(token: string) {
    return this.httpClient.put<Candidate>(AppConfig.settings.API + '/candidate/test/' + token,
      { params: { token } }
    );
  }

  sendFeedback(testToken: string, feedbackBody: any) {
    return this.httpClient.put(AppConfig.settings.API + '/tests/feedback/' + testToken, feedbackBody);
  }

  sendReport(testId: number) {
    return this.httpClient.put(AppConfig.settings.API + '/tests/send/report', {testId});
  }
}
